// extracted by mini-css-extract-plugin
module.exports = {"line":"coreka_line__33ral"};